class Semver {
  constructor(major, minor, patch) {
    this.major = major;
    this.minor = minor;
    this.patch = patch;
  }

  toString() {
    return `${this.major}_${this.minor}_${this.patch}`;
  }
}

function isIOS() {
  const ua = window.navigator.userAgent;
  return ua.indexOf("iPhone") > 0 || ua.indexOf("iPad") > 0;
}

export function getIOSSemver() {
  if (isIOS()) {
    const extract = window.navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return new Semver(
      parseInt(extract[1] || 0, 10),
      parseInt(extract[2] || 0, 10),
      parseInt(extract[3] || 0, 10)
    );
  } else {
    return null; // or [0,0,0]
  }
}


// WEBPACK FOOTER //
// ./src/components/common/iosVersion.js